<template>
    <spinner-until :condition="!!responses">
        <div class="report-widget-wbi-breakdown">
            <h3>{{ $i18n.gt('WBI_BREAKDOWN_INTRO') }}</h3>
            <br>
            <b-row><h2>{{ $i18n.gt('WBI_OVERALL_HEADING_A') }}</h2>&nbsp;{{ $i18n.gt('WBI_OVERALL_HEADING_B') }}</b-row>
            <b-row class="score-container"><h2>{{ overall }}</h2>&nbsp;&nbsp;{{ $i18n.gt('WBI_WELLBEING_LABEL') }}</b-row>
            <b-row><h2>{{ $i18n.gt('WBI_SECTIONS_HEADING') }}</h2>&nbsp;{{ $i18n.gt('WBI_OVERALL_HEADING_B') }}</b-row>
            <!-- {{ $i18n.gt('') }} -->
            <div class="score-container">
                <b-col>
                    <b-row><h2>{{ mind }}</h2>&nbsp;&nbsp;{{ $i18n.gt('QUESTIONNAIRE_WBI_SECTION_MIND_TITLE') }}</b-row>
                </b-col>
                <b-col>
                    <b-row><h2>{{ body }}</h2>&nbsp;&nbsp;{{ $i18n.gt('QUESTIONNAIRE_WBI_SECTION_BODY_TITLE') }}</b-row>
                </b-col>
                <b-col>
                    <b-row><h2>{{ work }}</h2>&nbsp;&nbsp;{{ $i18n.gt('QUESTIONNAIRE_WBI_SECTION_WORK_TITLE') }}</b-row>
                </b-col>
                <b-col>
                    <b-row><h2>{{ life }}</h2>&nbsp;&nbsp;{{ $i18n.gt('QUESTIONNAIRE_WBI_SECTION_LIFE_TITLE') }}</b-row>
                </b-col>
            </div>
            <!-- doing well answers -->
            <b-row><h2 v-html="$i18n.gt('WBI_DOING_WELL_HEADING')"></h2></b-row>
            <b-row class="percentage"><h2 class="percentage-num">{{ percentage(doingWell) }}</h2>%</b-row>
            <b-row class="answer-range" v-html="$i18n.gt('WBI_DOING_WELL_RANGE')"></b-row>
            <div class="answer-container">
                <b-col v-for="response in doingWell" :key="response.question_name">
                    <b-row><h2>{{response.points}}&nbsp;</h2>{{ $i18n.gt(`QUESTION_${response.question_name}_QUESTION_TEXT`) }}</b-row>
                </b-col>
                <div class="no-responses" v-if="doingWell.length === 0">
                    {{ $i18n.gt('WBI_DOING_WELL_BLANK') }}
                </div>
            </div>
            <!-- potential improvement answers -->
            <b-row><h2 v-html="$i18n.gt('WBI_POTENTIAL_IMPROVEMENT_HEADING')"></h2></b-row>
            <b-row class="percentage"><h2 class="percentage-num">{{ percentage(potentialImprovement) }}</h2>%</b-row>
            <b-row class="answer-range" v-html="$i18n.gt('WBI_POTENTIAL_IMPROVEMENT_RANGE')"></b-row>
            <div class="answer-container">
                <b-col v-for="response in potentialImprovement" :key="response.question_name">
                    <b-row><h2>{{response.points}}&nbsp;</h2>{{ $i18n.gt(`QUESTION_${response.question_name}_QUESTION_TEXT`) }}</b-row>
                </b-col>
                <div class="no-responses" v-if="potentialImprovement.length === 0">
                    {{ $i18n.gt('WBI_POTENTIAL_IMPROVEMENT_BLANK') }}
                </div>
            </div>
            <!-- burnout answers -->
            <b-row><h2 v-html="$i18n.gt('WBI_BURNOUT_HEADING')"></h2></b-row>
            <b-row class="percentage"><h2 class="percentage-num">{{ percentage(burnout) }}</h2>%</b-row>
            <b-row class="answer-range" v-html="$i18n.gt('WBI_BURNOUT_RANGE')"></b-row>
            <div class="answer-container">
                <b-col v-for="response in burnout" :key="response.question_name">
                    <b-row><h2>{{response.points}}&nbsp;</h2>{{ $i18n.gt(`QUESTION_${response.question_name}_QUESTION_TEXT`) }}</b-row>
                </b-col>
                <div class="no-responses" v-if="burnout.length === 0">
                    {{ $i18n.gt('WBI_BURNOUT_BLANK') }}
                </div>
            </div>
        </div>
    </spinner-until>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'

export default Vue.extend({
    name: 'ReportWidgetWbiBreakdown',
    props: {
        widget: Object,
    },
    data () {
        return {
            responses: null,
            surveyId: null,
            doingWell: [],
            potentialImprovement: [],
            burnout: [],
        }
    },
    computed: {
        overall() {
            return Math.floor(this.$store.state.patientParticipant.latestScoreDefs['WBI_OVERALL'].score.score)
        },
        mind() {
            return Math.floor(this.$store.state.patientParticipant.latestScoreDefs['WBI_MIND'].score.score)
        },
        body() {
            return Math.floor(this.$store.state.patientParticipant.latestScoreDefs['WBI_BODY'].score.score)
        },
        work() {
            return Math.floor(this.$store.state.patientParticipant.latestScoreDefs['WBI_WORK'].score.score)
        },
        life() {
            return Math.floor(this.$store.state.patientParticipant.latestScoreDefs['WBI_LIFE'].score.score)
        },
    },
    methods: {
        percentage (collection) {
            return Math.floor(collection.length / this.responses.length * 100)
        },
        async getLatestWbi() {
            const participant = await this.$api.getItem(this, 'participant', this.$store.state.patientParticipantId, ['latestSurveys'])
            const wbi = _.find(participant.latestSurveys, (i) => {
                if (i.questionnaire_code === 'WBI') return true
            })
            this.surveyId = wbi.survey_id
            await this.loadSurveyResponses()
            this.sortResponses()
        },
        async loadSurveyResponses() {
            const survey = await this.$api.getItem(this, 'survey', this.surveyId, ['responses'])
            this.responses = survey.responses
        },
        sortResponses() {
            this.responses.forEach((i, key) => {
                if (i.points >= 7){
                    this.doingWell.push(i)
                } else if (i.points > 3) {
                    this.potentialImprovement.push(i)
                } else this.burnout.push(i)
            })
        }
    },
    mounted () {
        this.getLatestWbi()
    },
})
</script>

<style lang="scss">
.report-widget-wbi-breakdown {
    background-color: #5432ff;
    padding: 1em;
    color: #fff;

    h1, h2, h3, h4, span, div {
        color: #fff
    }

    h3 {
        font-weight: normal;
    }

    .score-container {
        margin: 10px -16px;
        .col {
            width: 50%;
            display: inline-block;
        }
        h2 {
            font-size: 60px;
        }

    }

    .row {
        padding: 10px 1em;
        align-items: baseline;
        &.answer-range {
            text-transform: uppercase;
        }
        &.percentage {
            font-size: 80px;
            font-family: serif;
            font-weight: bold;
            padding: 10px 15px;
            .percentage-num {
                font-size: 160px;
                font-family: serif;
                font-weight: bolder
            }
        }
    }

    .answer-container {
        background: white;
        color: black;
        padding: 10px 0;
        margin: 10px -16px;

        .col {
            width: 50%;
            display: inline-block;
            color: #000;
            .row {
                color: black;
                h2 {
                    color: #5432ff;
                }
            }
        }
        h2 {
            font-weight: bold;
        }
        div.no-responses {
            padding: 15px;
            color: #999;
        }
    }
}
</style>
